module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o, asset, i, j, k, len, len1, len2, ref, ref1, ref2, skill, topic;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<div class='" + (['list-item', 'collapsible-container', 'js-project-row', "" + ($e($c((this.project.get("expanded") ? "active" : void 0))))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'>\n  <span class='" + (['icon', 'icon-move', 'sort-handle', "" + ($e($c((this.collection.editingProject() ? "hidden" : void 0))))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'></span>\n  <div class='collapsible-header'>\n    <div class='flex-wrapper'>\n      <div class='flex-checkbox'>\n        <div class='checkbox-toggle'>\n          <div class='checkbox'>\n            <input id='" + (this.project.get("id")) + "-project' name='' type='checkbox' value='false'>\n            <label for='" + ($e($c(this.project.get("id")))) + "-project'></label>\n          </div>\n          <label for='" + ($e($c(this.project.get("id")))) + "-project'></label>\n        </div>\n      </div>\n      <div class='flex-column js-toggle-collapsible'>\n        <h5 notranslate>");
      $o.push("          " + $e($c(this.project.get("title"))));
      if (this.project.get("showNotificationDot")) {
        $o.push("          <span class='notification-dot'></span>");
      }
      $o.push("        </h5>\n        <div class='subtext' notranslate>" + ($e($c(this.project.get("publication_name")))) + "</div>\n      </div>\n      <div class='actions flex-column project-actions'>");
      if (this.collection.editingProject()) {
        $o.push("        <a class='edit-disabled icon icon-only icon-pencil'></a>");
      } else {
        $o.push("        <a class='icon icon-only icon-pencil js-edit-project js-trigger-loading-state'></a>");
      }
      $o.push("        <div class='dropdown-align-right dropdown-container'>");
      if (this.project.get("public")) {
        $o.push("          <div class='dropdown-toggle icon icon-unlock'></div>");
      } else {
        $o.push("          <div class='dropdown-toggle icon icon-lock'></div>");
      }
      $o.push("          <ul class='dropdown-selection'>\n            <div class='group-header'>Who can see this?</div>\n            <ul>\n              <li class='js-toggle-public' data-public='false'>\n                <span class='icon icon-lock icon-with-text'>\n                  <var>Contently</var>\n                  only\n                </span>\n              </li>\n              <li class='js-toggle-public' data-public='true'>\n                <span class='icon icon-unlock icon-with-text'>\n                  Everyone\n                </span>\n              </li>\n            </ul>\n          </ul>\n        </div>\n        <span class='icon icon-x' data-behavior='confirm-delete'></span>\n      </div>\n    </div>\n  </div>\n  <div class='collapsible-content'>");
      if (this.project.get("story_format")) {
        $o.push("    <div class='row'>\n      <h6 class='as-label'>Format</h6>");
        $o.push("      " + $e($c(this.storyFormatHash[this.project.get("story_format")])));
        $o.push("    </div>");
      }
      if (this.project.get("url")) {
        $o.push("    <div class='row'>\n      <h6 class='as-label'>Project</h6>\n      <a class='blank' href='" + ($e($c(this.project.get("url")))) + "' target='_blank' notranslate>" + ($e($c(this.project.get("url")))) + "</a>\n    </div>");
      }
      if (this.project.get("external_file")) {
        $o.push("    <div class='row'>\n      <h6 class='as-label'>PDF</h6>\n      <span class='file-icon-w-name'>\n        <span class='icon icon-file'></span>\n        <span class='filename' notranslate>" + ($e($c(this.project.get("external_file_name")))) + "</span>\n      </span>\n    </div>");
      }
      if (this.project.get("description")) {
        $o.push("    <div class='row'>\n      <h6 class='as-label'>Description</h6>\n      <var>" + ($e($c(this.project.get("description")))) + "</var>\n    </div>");
      }
      if (this.project.get("topics").length > 0) {
        $o.push("    <div class='row topics'>\n      <h6 class='as-label'>Topics</h6>");
        ref = this.project.get("topics");
        for (i = 0, len = ref.length; i < len; i++) {
          topic = ref[i];
          $o.push("      <span class='comma'>" + ($e($c(topic))) + "</span>");
        }
        $o.push("    </div>");
      }
      if (this.project.get("skills").length > 0) {
        $o.push("    <div class='row skills'>\n      <h6 class='as-label'>Skills</h6>");
        ref1 = this.project.get("skills");
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          skill = ref1[j];
          $o.push("      <span class='comma'>" + ($e($c(skill))) + "</span>");
        }
        $o.push("    </div>");
      }
      if (this.project.get("use_image") && this.project.get("assets").length > 0) {
        $o.push("    <div class='row'>\n      <h6 class='as-label'>Images</h6>\n      <div class='clip-images'>");
        ref2 = this.project.get("assets");
        for (k = 0, len2 = ref2.length; k < len2; k++) {
          asset = ref2[k];
          $o.push("        <div class='image-wrapper'>\n          <img src='" + ($e($c(asset.small))) + "'>\n        </div>");
        }
        $o.push("      </div>\n    </div>");
      }
      $o.push("  </div>\n  <div class='js-add-skills-container'></div>\n</div>\n<div class='delete-confirmation js-prevent-toggle'>\n  <div class='delete-content-wrapper'>\n    <div class='delete-content'>\n      Are you sure?\n      <a class='pipe-separated' href='javascript:;' title='Cancel' data-behavior='cancel-delete'>Cancel</a>\n      <a class='js-delete-project js-trigger-loading-state pipe-separated'>Delete</a>\n    </div>\n  </div>\n</div>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "").replace(/[\s\n]*\u0091/mg, '').replace(/\u0092[\s\n]*/mg, '');
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/projects/templates/show.js.hamlc
// module id = 1518
// module chunks = 18